// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1Piz0","icon":"styles__icon___2K976","name":"styles__name___13uQZ"};